import React from 'react';

export default function AlertBell() {
  return (
    <div className="relative">
      <button className="p-2 rounded-full hover:bg-gray-100">
        🔔
      </button>
    </div>
  );
}